import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { BetterBuyProductDetail } from '@app/better-buys/models/better-buys.model';
import { ProductPropertiesEnum } from '@usf/product-types';
import { QuantityUpdate } from '@shared/models/quantity-update';
import { PriceViewModel } from '@shared/models/price-view.model';

@Component({
  selector: 'app-better-buys-conversion-product-card',
  templateUrl: './better-buys-conversion-product-card.component.html',
  styleUrls: ['./better-buys-conversion-product-card.component.scss'],
})
export class BetterBuysConversionProductCardComponent {
  @Input() product: BetterBuyProductDetail;
  @Input() platform: PlatformEnum;
  @Input() samePackSize: boolean;
  @Input() annualSavings: number;
  @Input() annualSavingsUom: string;
  @Input() savingsPerCase: number;
  @Input() savings: number;
  @Input() savingsUom: string;
  @Input() pricingDisabled: boolean;
  @Input() originalPricing: PriceViewModel;
  @Input() isOnline: boolean;

  @Output() changeQuantityEmitter = new EventEmitter<QuantityUpdate>();
  @Output() acceptSwapEmitter = new EventEmitter<any>();
  @Output() productImageClickEmitter: EventEmitter<any> = new EventEmitter();

  readonly PlatformEnum = PlatformEnum;
  readonly propertiesEnum = ProductPropertiesEnum;

  constructor() {}

  changeQuantityHandler(event: QuantityUpdate) {
    this.changeQuantityEmitter.emit(event);
  }

  acceptSwap() {
    this.acceptSwapEmitter.emit();
  }

  handleProductImageClick() {
    this.productImageClickEmitter.emit(this.product.productNumber);
  }
}
